module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fieldKey":"Key","fieldValue":"Value","addNew":"+ Add new"},"et":{"fieldKey":"Key","fieldValue":"Value","addNew":"+ Add new"},"ru":{"fieldKey":"Key","fieldValue":"Value","addNew":"+ Add new"}}')
  delete Component.options._Ctor
}
